import { mountVueWithProps } from '../../common/utils/vue';
import PayingRegistrationApp from '../../articles/PayingRegistrationApp';
import { execCopy } from '../utils/copy';

document.addEventListener('DOMContentLoaded', () => {
  mountVueWithProps({
    element: document.querySelector('.js-article-page-paying-registration'),
    component: PayingRegistrationApp
  });
});

function copyUrl() {
  execCopy({ selector: '#article_url' });
  const copiedMessage = document.querySelector('.topics-share-dialog');

  copiedMessage.style.display = 'block';
  setTimeout(function() {
    copiedMessage.style.display = 'none';
  }, 2000);
}

window.copyArticleUrl = copyUrl;
